import { Users } from '@platform/client';
import { Tabs } from '@platform/components';
import { AuthedPage, HeaderFooterLayout } from '../../app';
import { OrganizationCards } from './OrganizationCards';
import { ProjectCards } from './ProjectCards';

const getInitialTab = (canBrowseOrganizations: boolean) => {
  if (typeof window === 'undefined' || !canBrowseOrganizations) {
    return 'projects';
  }
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('view') === 'organizations' ? 'organizations' : 'projects';
};

const ProjectSearch = () => {
  const { data: user } = Users.useGetCurrentUser();
  const canBrowseOrganizations = !(
    user?.accountType === 'experteer' && user.professionalType === 'ey'
  );

  return (
    <AuthedPage>
      <HeaderFooterLayout useDashboardHeader>
        <div className='-mt-12 flex flex-col gap-4 px-4 sm:px-11 pt-8 pb-6 w-full'>
          <div className='text-4xl font-semibold text-gray-900'>
            Find a project or create one with an organization
          </div>
          <Tabs
            title='Find a project or an organization'
            variant='segmented'
            keepTabsOnMobile
            defaultSelectedKey={getInitialTab(canBrowseOrganizations)}
            items={[
              { id: 'projects', tabLabel: 'Projects', content: <ProjectCards /> },
              ...(canBrowseOrganizations ?
                [{ id: 'organizations', tabLabel: 'Organizations', content: <OrganizationCards /> }]
              : []),
            ]}
          />
        </div>
      </HeaderFooterLayout>
    </AuthedPage>
  );
};

export default ProjectSearch;
